import { decodeHtmlEntities } from '@opallabs/lambda'

export const setAssetReferenceData = (asset_reference) => {
  if (!asset_reference) return {}
  return {
    id: asset_reference.id,
    uuid: asset_reference.uuid,
    asset_type: asset_reference.asset_type,
    alt_text: asset_reference.alt_text,
    description: decodeHtmlEntities(asset_reference.description),
    filename: decodeHtmlEntities(asset_reference.filename),
    filesize: asset_reference.filesize,
    format: asset_reference.format,
    full_url: asset_reference.full_url,
    height: asset_reference.height,
    meta_data: asset_reference.meta_data,
    preview_url: asset_reference.preview_url,
    is_processing: asset_reference.is_processing,
    processing_percent: asset_reference.processing_percent,
    title: asset_reference.title,
    width: asset_reference.width,
  }
}
